import {get, startCase} from 'lodash'
// var CircularJSON = require('circular-json')

import Dropzone from 'react-dropzone'
import request from 'superagent'
import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'

// TODO: don't accept any file if 'accepts' is not explicitly set ...
class InputDropzone extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      value   : '',
      schema  : this.props.schema,
      classes : get(this.props, 'AXGClasses.input', 'form-group'),
      endpoint: get(this.props.schema, 'endpoint', ''),
      fileNames: [],
      // floatingLabel : get(this.props, 'AXGOptions.floating-label', true),
      updates: get(this.props.schema, 'updates', ''),
      accepts: get(this.props.schema, 'accepts', ''),
    }
  }

  handleInputChange(e) {
    // var file = this.refs.fileInput.getDOMNode().files[0]
    // console.log(`file: ${file}`)
    // console.log(`refs: ${CircularJSON.stringify(this.refs.fileInput)}`)
    var value = e.target.value
    console.log(`value: ${value}`)
    this.setState({
      value: value,
      title: value,
    })
    this.props.actions.setAppxigonState({
      key   : [this.props.AXGKey],
      value : value,
    })
  }

  onDrop(files) {
    var component = this
    var fileNames = []
    console.log(`Received files: ${JSON.stringify(files)}`)
    console.log(`Target endpoint: ${this.state.endpoint}`)
    if (this.state.endpoint) {
      var req = request.post(this.state.endpoint)
      files.forEach((f)=> {
        fileNames.push(f.name)
        req.attach(f.name, f)
      })
      req.end(()=> {
        fileNames.forEach((n)=> {
          console.log(`Upload completed: ${n}.`)
        })
        component.setState({
          fileNames: fileNames
        })
        if (component.state.updates) {
          console.log(`Update dependency for: ${component.state.updates}`)
          component.props.actions.setAppxigonState({
            key : `dependency.${component.state.updates}`,
            // make it a string. value not important, just for redux value change detection
            value: JSON.stringify(fileNames),
          })
        }
      })
    }
  }

  onOpenClick() {
    this.refs.dropzone.open()
  }

  componentWillMount() {
    var component = this
    var currentValue = get(component.props.appxigonState, component.props.AXGKey,'')
    console.log(`input currentValue (${component.props.AXGKey}): ${currentValue}`);
    component.setState({
      value: currentValue,
    })
  }

  render() {
    // console.log(`input-text schema (${this.state.id}): ${JSON.stringify(this.state.schema)}`)
    var schema = this.state.schema
    var title = get(schema, 'title', startCase(this.state.id))
    var icon = get(schema, 'icon', null)
    var helpMessage = get(schema, 'help-message', '')
    var id = `input-${this.state.id}`
    return (
      <div
        className={
          this.state.classes +
          (this.state.floatingLabel ? ' label-floating' : '') +
          (this.props.show ? '' : ' hidden')
        }>
        <div className='input-group'>
          {
            <span class="input-group-addon">
              <i className="material-icons">{ icon }</i>
            </span>
          }
          {
            <label htmlFor={id}>{title}</label>
          }
          <Dropzone ref='dropzone'
            onDrop={this.onDrop.bind(this)}
            accept={this.state.accepts}>
            <div style={{padding: 20}}>
              Drop Pricing Source XLSX file here, or click to select files to upload ...
              <hr/>
              {
                <div>
                  <b>
                    {`Upload completed:`}
                  </b>
                  {
                    this.state.fileNames.map(
                      (n)=>
                        <div key={n}>
                          <b> {n} </b>
                        </div>
                    )
                  }
                </div>
              }
            </div>
          </Dropzone>
          {
            helpMessage ? <p className="help-block">{ helpMessage }</p> : null
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InputDropzone)



// WEBPACK FOOTER //
// ./item-types/input-dropzone.js